import { cn } from "@/lib/utils";

const MAP = {
  draft: "border-zinc-300 text-zinc-700 bg-zinc-50",
  validated: "border-sky-500/40 text-sky-700 bg-sky-500/5",
  released: "border-amber-500/40 text-amber-700 bg-amber-500/5",
  published: "border-emerald-500/40 text-emerald-700 bg-emerald-500/5",
  authorized: "border-emerald-500/40 text-emerald-700 bg-emerald-500/5",
  consumed: "border-emerald-500/40 text-emerald-600 bg-emerald-500/10",
  expired: "border-zinc-300 text-zinc-500 bg-zinc-50",
  deactivated: "border-rose-500/40 text-rose-600 bg-rose-500/5",
  running: "border-amber-500/40 text-amber-700 bg-amber-500/5",
  awaiting_approval: "border-orange-500/50 text-orange-600 bg-orange-500/10",
  completed: "border-emerald-500/40 text-emerald-700 bg-emerald-500/5",
  failed: "border-rose-500/40 text-rose-600 bg-rose-500/5",
  cancelled: "border-zinc-300 text-zinc-500 bg-zinc-50",
};

export default function StateBadge({ state, className }) {
  return (
    <span
      data-testid={`state-badge-${state}`}
      className={cn(
        "inline-flex items-center gap-1.5 px-2 py-0.5 rounded-sm border text-[10px] font-mono uppercase tracking-wider",
        MAP[state] || MAP.draft,
        className,
      )}
    >
      <span className="w-1 h-1 rounded-full bg-current" />
      {state}
    </span>
  );
}
